import { File, FileGroup, TypedFiles } from '../../../../types/catalog';
import { Fragment } from 'react';

const FileWrapper = ({ file }: { file: File | TypedFiles }) => {
    if ((file as TypedFiles).type) {
        const { type, list } = file as TypedFiles;
        return (
            <Fragment>
                <div className="product-documents__label">{type}</div>
                {list.map(({ url, name }, idx) => (
                    <li key={idx} className="product-documentation-items__list-item" title={name}>
                        <a
                            className="product-documentation-items__list-link"
                            href={url}
                            style={{ verticalAlign: '3px' }}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="12" height="16">
                                <path
                                    d="M11.559 3.07L8.938.45a1.507 1.507 0 00-1.06-.44H1.5A1.5 1.5 0 000 1.51v13a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5V4.13a1.509 1.509 0 00-.441-1.06zm-1.181.94H8V1.63zM1.5 14.51v-13h5v3.25a.745.745 0 00.75.75h3.25v9h-9zm7.819-4.49a3.022 3.022 0 00-2.013-.2 2.747 2.747 0 01-1.15-1.45 3.924 3.924 0 00.169-1.75.7.7 0 00-1.331-.19 4.5 4.5 0 00.218 2.1 25.354 25.354 0 01-1.106 2.33 2.851 2.851 0 00-1.593 1.44c-.1.49.812 1.73 2.378-.97a14.083 14.083 0 012.137-.63 4.137 4.137 0 001.744.53.722.722 0 00.547-1.21zm-6.191 2.43a3.692 3.692 0 01.95-1.09 2.605 2.605 0 01-.95 1.09zm2.55-5.96c.231 0 .21 1.01.056 1.28a2.649 2.649 0 01-.056-1.28zm-.762 4.27a11.611 11.611 0 00.772-1.71 3.362 3.362 0 00.94 1.11 11.2 11.2 0 00-1.712.6zm4.112-.15s-.156.18-1.166-.25c1.097-.08 1.279.17 1.166.25z"
                                    fill="#67ae3e"
                                    fillRule="evenodd"
                                />
                            </svg>
                            <span style={{ fontSize: '14px' }}>{name}</span>
                        </a>
                    </li>
                ))}
            </Fragment>
        );
    } else {
        const { url, name } = file as File;
        return (
            <li className="product-documentation-items__list-item" title={name}>
                <a
                    className="product-documentation-items__list-link"
                    href={url}
                    style={{ verticalAlign: '3px' }}
                    target="_blank"
                    rel="noreferrer"
                >
                    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="12" height="16">
                        <path
                            d="M11.559 3.07L8.938.45a1.507 1.507 0 00-1.06-.44H1.5A1.5 1.5 0 000 1.51v13a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5V4.13a1.509 1.509 0 00-.441-1.06zm-1.181.94H8V1.63zM1.5 14.51v-13h5v3.25a.745.745 0 00.75.75h3.25v9h-9zm7.819-4.49a3.022 3.022 0 00-2.013-.2 2.747 2.747 0 01-1.15-1.45 3.924 3.924 0 00.169-1.75.7.7 0 00-1.331-.19 4.5 4.5 0 00.218 2.1 25.354 25.354 0 01-1.106 2.33 2.851 2.851 0 00-1.593 1.44c-.1.49.812 1.73 2.378-.97a14.083 14.083 0 012.137-.63 4.137 4.137 0 001.744.53.722.722 0 00.547-1.21zm-6.191 2.43a3.692 3.692 0 01.95-1.09 2.605 2.605 0 01-.95 1.09zm2.55-5.96c.231 0 .21 1.01.056 1.28a2.649 2.649 0 01-.056-1.28zm-.762 4.27a11.611 11.611 0 00.772-1.71 3.362 3.362 0 00.94 1.11 11.2 11.2 0 00-1.712.6zm4.112-.15s-.156.18-1.166-.25c1.097-.08 1.279.17 1.166.25z"
                            fill="#67ae3e"
                            fillRule="evenodd"
                        />
                    </svg>
                    <span style={{ fontSize: '14px' }}>{name}</span>
                </a>
            </li>
        );
    }
};

function FileCard({ fileGroup }: { fileGroup: FileGroup }) {
    return (
        <div className="product-documentation-items__item">
            <span className="product-documentation-items__title">{fileGroup.name} </span>
            <ul className="product-documentation-items__list">
                {fileGroup.files.map((f, idx) => (
                    <FileWrapper key={idx} file={f} />
                ))}
            </ul>
        </div>
    );
}

export default FileCard;
